export default __webpack_public_path__ + "static/media/snow-cone.df13f013.png";